import { Dropdown } from "semantic-ui-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import { Checkbox } from "components/ui/checkbox";
import { SELECT_COLUMN_ID } from "constants/Constants";
import { ScrollColumn } from "components/BaseTableV3/ScrollColumn";
import CustomDropdown from "components/CustomDropdown";
import withRoleCheck from "components/hocs/withRoleCheck";
import HoldMessagePreview from "components/HoldMessagePreview";
import { RoundedAudioPlayer } from "components/RoundedAudioPlayer";

const AssignAgentsDropdownItem = withRoleCheck(Dropdown.Item, [
  ACL_RELATIONSHIPS.twilioPhoneNumber.assignAgents,
]);

const AssignHoldMessageDropdownItem = withRoleCheck(Dropdown.Item, [
  ACL_RELATIONSHIPS.twilioPhoneNumber.assignHoldMessage,
]);

export const getTwilioPhoneNumbersTableColumns = ({
  handleAssignAgents,
  handleAssignVoicemail,
  handleAssignHoldMessage,
}) => {
  return [
    {
      id: SELECT_COLUMN_ID,
      size: 60,
      enableSorting: false,
      meta: {
        isDisplay: true,
      },
      header: ({ table }) => (
        <Checkbox
          {...{
            checked: table.getIsAllRowsSelected(),
            indeterminate: table.getIsSomeRowsSelected(),
            onCheckedChange: checked => table.toggleAllRowsSelected(!!checked),
            "aria-label": "Select all rows",
          }}
        />
      ),
      cell: ({ row }) => (
        <div>
          <Checkbox
            {...{
              checked: row.getIsSelected(),
              disabled: !row.getCanSelect(),
              indeterminate: row.getIsSomeSelected() && !row.getIsSelected(),
              onCheckedChange: checked => row.toggleSelected(!!checked),
              "aria-label": "Select row",
            }}
          />
        </div>
      ),
    },
    {
      header: "ID",
      id: "ID",
      accessorKey: "id",
      size: 60,
      cell: ({ row }) => (
        <p style={{ fontWeight: "bold" }}>{row.original.id}</p>
      ),
    },
    {
      header: "Number",
      id: "Number",
      accessorKey: "number",
      size: 150,
    },
    {
      header: "Country Code",
      id: "Country Code",
      accessorKey: "country_code",
      size: 130,
    },
    {
      header: "Agents",
      id: "Agents",
      accessorKey: "agents",
      size: 200,
      cell: ({ row }) => (
        <ScrollColumn>
          {row.original.agents.map(agent => (
            <li key={agent.id}>{agent.name}</li>
          ))}
        </ScrollColumn>
      ),
    },
    {
      header: "Voicemail",
      id: "Voicemail",
      accessorKey: "voicemail_attachment.url",
      enableSorting: false,
      size: 120,
      cell: ({ row }) => {
        const url = row.original?.voicemail_attachment?.url;
        return url ? (
          <RoundedAudioPlayer
            id={`audio-el-${row.index}`}
            src={url}
            showDuration
            download
          />
        ) : null;
      },
    },
    {
      header: "Hold Message",
      id: "Hold Message",
      accessorKey: "hold_message",
      enableSorting: false,
      size: 240,
      cell: ({ row }) => {
        const { id, hold_message, hold_message_language, hold_message_voice } =
          row.original;
        if (!hold_message) {
          return (
            <span className="tw:text-muted-foreground">
              Using default hold message
            </span>
          );
        }
        return (
          <div className="tw:flex tw:items-center tw:gap-2">
            <HoldMessagePreview
              holdMessage={hold_message}
              language={hold_message_language}
              voice={hold_message_voice}
              id={`hold-message-preview-${id}`}
            />
            <div className="tw:flex tw:min-w-0 tw:flex-col">
              <span className="tw:truncate" title={hold_message}>
                {hold_message}
              </span>
              <span className="tw:text-xs tw:text-muted-foreground">
                {hold_message_language}
              </span>
            </div>
          </div>
        );
      },
    },
    {
      header: <div></div>,
      id: "Actions",
      accessorKey: "actions",
      enableSorting: false,
      enableResizing: false,
      size: 60,
      meta: {
        isDisplay: true,
      },
      cell: ({ row }) => {
        const {
          id,
          voicemail_id,
          agents,
          hold_message,
          hold_message_language,
          hold_message_voice,
        } = row.original;
        const agentIds = agents.map(agent => agent.id);

        return (
          <CustomDropdown icon="ellipsis horizontal">
            <Dropdown.Menu direction="left">
              <AssignAgentsDropdownItem
                className="primary"
                content="Assign Agents"
                icon="user"
                onClick={() => handleAssignAgents([id], agentIds)}
              />
              <Dropdown.Item
                className="primary"
                content="Assign Voicemail"
                icon="file audio"
                onClick={() => handleAssignVoicemail(id, voicemail_id)}
              />
              <AssignHoldMessageDropdownItem
                className="primary"
                content="Set Hold Message"
                icon="comment"
                onClick={() =>
                  handleAssignHoldMessage(id, {
                    hold_message,
                    hold_message_language,
                    hold_message_voice,
                  })
                }
              />
            </Dropdown.Menu>
          </CustomDropdown>
        );
      },
    },
  ];
};

export const getTwilioPhoneNumbersTableFilters = () => {
  return [];
};
